function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
export default (function (_ref) {
  var _button, _link;
  var colors = _ref.colors,
    mediaQueries = _ref.mediaQueries;
  return {
    link: (_link = {
      fontSize: '16px',
      fontWeight: 400,
      padding: '10px 0 25px',
      margin: '0 20px',
      textDecoration: 'none',
      color: colors.grayDark,
      transition: 'color 0.2s',
      display: 'inline-block',
      lineHeight: '24px',
      borderStyle: 'solid',
      borderColor: 'transparent',
      borderWidth: '0 0 3px',
      cursor: 'pointer',
      '&:hover': _defineProperty({
        color: colors.primary
      }, mediaQueries.breakpointTablet, {
        color: colors.white
      }),
      '&.additional': _defineProperty({
        display: 'none'
      }, mediaQueries.breakpointTablet, {
        display: 'block',
        fontSize: '17px'
      }),
      '&.hideOnDesktop': _defineProperty({
        display: 'none'
      }, mediaQueries.breakpointTablet, {
        display: 'block'
      }),
      '&.active': _defineProperty({
        fontWeight: 700,
        borderColor: colors.primary
      }, mediaQueries.breakpointTablet, {
        fontWeight: 400
      }),
      '&.button': (_button = {
        borderColor: colors.secondary,
        borderRadius: '3px',
        borderWidth: '1px',
        color: colors.secondary,
        fontSize: '14px',
        fontWeight: 500,
        margin: '0 10px 18px',
        padding: '10px 20px 8px',
        textTransform: 'uppercase',
        transition: 'border-color 0.2s, color 0.2s',
        '&:hover': {
          borderColor: colors.primary
        }
      }, _defineProperty(_button, mediaQueries.laptop, {
        padding: '10px 20px'
      }), _defineProperty(_button, mediaQueries.laptopSmall, {
        padding: '10px 20px'
      }), _defineProperty(_button, mediaQueries.breakpointTablet, {
        borderRadius: 0,
        padding: 0,
        borderWidth: 0
      }), _defineProperty(_button, '&.inverse', {
        backgroundColor: colors.secondary
      }), _button),
      '&.inverse': {
        color: colors.white
      },
      '&.activeButton': {
        borderColor: colors.primary
      },
      '&.hideOnMobile': _defineProperty({}, mediaQueries.breakpointTablet, {
        display: 'none'
      })
    }, _defineProperty(_link, mediaQueries.breakpointLaptop, {
      margin: '0 10px'
    }), _defineProperty(_link, mediaQueries.laptop, {
      padding: '10px 0 27px'
    }), _defineProperty(_link, mediaQueries.laptopSmall, {
      fontSize: '14px',
      padding: '10px 0 27px'
    }), _defineProperty(_link, mediaQueries.breakpointTablet, {
      display: 'block',
      color: colors.white,
      padding: 0,
      margin: '14px 0',
      fontSize: '22px',
      borderWidth: 0
    }), _link)
  };
});